<template>
    <el-config-provider :button="buttonConfig" :locale="zhCn">
        <router-view />
    </el-config-provider>
</template>

<script setup lang="ts">
import { reactive } from "vue";
import { ElConfigProvider } from "element-plus";
import zhCn from "element-plus/es/locale/lang/zh-cn";

const buttonConfig = reactive({ autoInsertSpace: false });
zhCn.el.pagination = Object.assign(zhCn.el.pagination, { goto: "转到" });
</script>
